import React, { useState, useEffect, useRef } from 'react'; 
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

// Components 

import { useTranslation } from 'react-i18next';
import { serveFile } from '../../../../routes/doctor/files';
import CircularProgress from '@mui/material/CircularProgress';
import Header from './items/Header';


const NoteViewer: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const navigate = useNavigate(); 

    const { t } = useTranslation(); 

    const colors = useAppSelector(state => state.theme.colors);
    const title = useAppSelector(state => state.consultationNote.title); 

    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    const blobFileUrl = useAppSelector(state => state.consultationNote.blobFileUrl) as any; 

    const [fileUrl, setFileUrl] = useState(''); 

    // -- 

    // const handleFile = async () => { 

    //     const res = await serveFile(selectedFile?._id) as any; 
        
    //     const fileBlob = new Blob([res.data], { type: res.headers['content-type'] });
    
    //     setFileUrl(URL.createObjectURL(fileBlob)); 

    // }; 

    // -- 

    useEffect(() => { 

        if (blobFileUrl) { 

            setFileUrl(blobFileUrl);

        }; 

    },[blobFileUrl]); 

    // --

    return (

        <Box 
            style={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'flex-start',
                width: '100vw',
                height: '100vh', 
                backgroundColor: 'black', 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 1000000000
        }}>

            <Header title={title} />

            {fileUrl ?
                <iframe
                ref={iframeRef}
                src={fileUrl}
                style={{ 
                    width: '100%', 
                    height: '100%',
                    border: 'none'
                }}
                title="PDF Viewer"
                />: 
            <CircularProgress size={30} sx={{ marginTop: '40vh' }} />}

        </Box>
  );
};

export default NoteViewer;